import React from "react";
import { Theme } from "@mui/material";
import { toCustomShort } from "@helpers";
import { CustomTooltipContainer } from "../components/CustomTooltipContainer";

interface Props {
  label?: string;
  points: Partial<{
    name: string;
    value: number;
    color: string;
  }>[];
  theme: Theme;
}

export const CustomTooltip = ({ label, points = [], theme }: Props) => {
  if (!label || !points) return null;

  const body3Styles = {
    ...(theme.typography.body3 as any),
  };

  return (
    <CustomTooltipContainer withShadow theme={theme}>
      <div>
        {label && (
          <div
            style={{
              ...body3Styles,
              marginBottom: theme.spacing(2),
              color: theme.palette.text.onTooltipPrimary,
            }}
          >
            {label}
          </div>
        )}
        {points.map((point: any) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: theme.spacing(1.5),
            }}
          >
            <div
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: point.color,
              }}
            />
            <div
              style={{
                ...body3Styles,
                fontWeight: 400,
                color: theme.palette.text.onTooltipPrimary,
              }}
            >
              {point.name}:
            </div>
            <div
              style={{
                ...body3Styles,
                color: theme.palette.text.onTooltipPrimarySub,
              }}
            >
              {toCustomShort(point.value)}
            </div>
          </div>
        ))}
      </div>
    </CustomTooltipContainer>
  );
};
